import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class BackupService {
  /**
   * sAPI URL that points to the Cloud Function endpoint
   * which handles backup and restore operations.
   */
  private apiUrl = 'https://us-central1-neat-planet-378416.cloudfunctions.net/restoreNode'

  constructor(private http: HttpClient) {}

  /**
   * Fetch the list of available backups
   * @param projectId - the ID of the project
   * @returns Observable with an array of backups
   */
  // Trigger http request with only project id to get list of backfiles

  getBackups(projectId: string): Observable<any> {
    return this.http.get(this.apiUrl, {
      params: { projectId }
    })
  }

  /**
   * Restore a specific node in the project from a selected backup.
   *
   * @param projectId - the ID of the project
   * @param node - the specific part (node) of the project’s data to restore.
   *               Example: "users", "products".
   *               Restoring only one section instead of the entire data.
   * @param selectedBackup - the index of the chosen backup file
   */
  backupNode(projectId: string, node: string, selectedBackup: number = 0): Observable<any> {
    return this.http.get(this.apiUrl, {
      params: { projectId, node, selectedBackup }
    })
  }
}
